import { queryOptions } from '@tanstack/react-query';
import { fetchActivityLogSummary } from './activityLogApi';
import { activityLogKeys } from './activityLogKeys';
import type { ActivityLogSummaryFilters } from './activityLogTypes';

export const activityLogSummaryQueryOptions = (
  incidentId?: string,
  filters: ActivityLogSummaryFilters = {}
) =>
  queryOptions({
    queryKey: activityLogKeys.summary(incidentId ?? '', filters),
    queryFn: ({ signal }) =>
      fetchActivityLogSummary(incidentId ?? '', filters, signal),
    enabled: Boolean(incidentId),
  });
